module.exports = __webpack_public_path__ + "static/img/banner1.c399f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/banner1.jpg
// module id = 3ME+
// module chunks = 2